'use strict'

export default class User {
    constructor(
        gender="",
        fullname="",
        phone="",
        username = "",
        location=[],
        address = "",
        email = "",
        password = "",
        photo = ""
    ) {
        this.fullname=fullname
        this.gender=gender
        this.phone=phone
        this.username = username
        this.location=location
        this.address = address
        this.email = email
        this.password = password
        this.photo = photo
    }

}

